export default [
  {
    path: 'companies',
    roles: ['ROLE_SUN_ADMIN_COMPANY', 'ROLE_SUN_LOCAL_ADMIN'],
  },
  {
    path: 'accounts',
    roles: ['ROLE_SUN_ADMIN_ACCOUNT', 'ROLE_SUN_LOCAL_ADMIN'],
  },
  {
    path: 'app-resources',
    roles: ['ROLE_SUN_ADMIN_APPS'],
  },
  {
    path: 'paymentTerminals',
    roles: ['ROLE_SUN_ADMIN_PAYMENT_TERMINAL', 'ROLE_SUN_LOCAL_ADMIN'],
  },
  {
    path: 'paymentServers',
    roles: ['ROLE_SUN_ADMIN_PAYMENT_SERVER', 'ROLE_SUN_LOCAL_ADMIN'],
  },
  {
    path: 'printers',
    roles: ['ROLE_SUN_ADMIN_PRINTER', 'ROLE_SUN_LOCAL_ADMIN'],
  },
  {
    path: 'licenses',
    roles: ['ROLE_SUN_ADMIN_LICENSE'],
  },
  {
    path: 'print-servers',
    roles: ['ROLE_SUN_ADMIN_PRINT_SERVER', 'ROLE_SUN_LOCAL_ADMIN'],
  },
  {
    path: 'caller-id-servers',
    roles: ['ROLE_SUN_ADMIN_CALLERID_SERVER'],
  },
  {
    path: 'catalog',
    roles: ['ROLE_SUN_ADMIN_CATALOG', 'ROLE_SUN_LOCAL_ADMIN'],
  },
  {
    path: 'tables',
    roles: ['ROLE_SUN_ADMIN_TABLE_CREATOR', 'ROLE_SUN_LOCAL_ADMIN'],
  },
  {
    path: 'table-categories',
    roles: ['ROLE_SUN_ADMIN_TABLE_CREATOR', 'ROLE_SUN_LOCAL_ADMIN'],
  },
  {
    path: 'corporations',
    roles: ['ROLE_SUN_ADMIN_CORPORATION'],
  },
  {
    path: 'web-space-dashboard',
    roles: ['ROLE_SUN_ADMIN_WEB_RESOURCE'],
  },
  {
    path: 'domain-dashboard',
    roles: ['ROLE_SUN_ADMIN_WEB_RESOURCE'],
  },
  {
    path: 'license-reports',
    roles: ['ROLE_SUN_ADMIN'],
  },
  {
    path: 'invoices',
    roles: ['ROLE_SUN_ADMIN_PRICING', 'ROLE_SUN_ADMIN_COMPANY'],
  },
  {
    path: 'resource-tracking',
    roles: ['ROLE_SUN_ADMIN_PRICING'],
  },
  {
    path: 'audit-log',
    roles: ['ROLE_SUN_ADMIN'],
  },
  {
    path: 'auto-jobs',
    roles: ['ROLE_SUN_ADMIN'],
  },
  {
    path: 'config-updates',
    roles: ['ROLE_SUN_ADMIN'],
  },
  {
    path: 'discount',
    roles: ['ROLE_SUN_ADMIN'],
  },
  {
    path: 'language-mappings',
    roles: ['ROLE_SUN_ADMIN'],
  },
  {
    path: 'moon-backup',
    roles: ['ROLE_SUN_ADMIN'],
  },
  {
    path: 'moon-instance-dashboard',
    roles: ['ROLE_SUN_ADMIN'],
  },
  {
    path: 'print-templates',
    roles: ['ROLE_SUN_ADMIN'],
  },
  {
    path: 'system-logs',
    roles: ['ROLE_SUN_ADMIN'],
  },
  {
    path: 'web-shop-dashboard',
    roles: ['ROLE_SUN_ADMIN', 'ROLE_SUN_LOCAL_ADMIN'],
  },
  {
    path: 'webshopusage-reports',
    roles: ['ROLE_SUN_ADMIN'],
  },
  {
    path: 'cash-register',
    roles: ['ROLE_SUN_ADMIN_CASHREGISTER'],
  },
  {
    path: 'images',
    roles: ['ROLE_SUN_ADMIN_CATALOG', 'ROLE_SUN_LOCAL_ADMIN'],
  },
];



// WEBPACK FOOTER //
// ./src/router/role-map.js